// ---- Group-card click decision ------------------------------------------
// Pure decision for what tapping a team does, kept out of the React component
// so the (slightly fiddly) rules can be unit-tested directly.
//
//   currentPos: the place this team already holds — "first" | "second" | "third" | null
//   active:     the selected place chip — "first" | "second" | "third" | null
//   result:     the group's current { first, second, third } assignment
//
// Returns one of:
//   { type: "assign", pos, reselect }  → setPos(g, pos, team); if reselect, setActive(reselect)
//   { type: "clear", pos }             → clearPos(g, pos); setActive(pos)
//   { type: "none" }                   → do nothing

const ORDER = ["first", "second", "third"];

// Highest-priority place that has no team once `justFilled` is also counted as
// filled — or null if the podium is complete.
function nextEmptyPlace(result, justFilled) {
  return ORDER.find(p => p !== justFilled && !result[p]) || null;
}

export function groupClickAction(currentPos, active, result = {}) {
  if (active && active !== currentPos) {
    // Assigning to the active place. If the team already held another place,
    // that place is now vacated — re-select it (swap workflow). Otherwise this
    // is a fresh pick: advance to the next-highest empty place so you can fill
    // the podium top-down.
    const reselect = currentPos || nextEmptyPlace(result, active);
    return { type: "assign", pos: active, reselect };
  }
  if (currentPos) {
    // Either the team sits in the active slot (toggle off) or no selector is
    // active and the team holds a place — unassign and select that place.
    return { type: "clear", pos: currentPos };
  }
  return { type: "none" };
}
